/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as SafelinkDefs from './defs.defs.js'

const $nsid = 'tools.ozone.safelink.removeRule'

export { $nsid }

/** Remove an existing URL safety rule */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    url: l.string(),
    pattern: l.ref<SafelinkDefs.PatternType>(
      (() => SafelinkDefs.patternType) as any,
    ),
    comment: l.optional(l.string()),
    createdBy: l.optional(l.string({ format: 'did' })),
  }),
  l.payload(
    'application/json',
    l.ref<SafelinkDefs.Event>((() => SafelinkDefs.event) as any),
  ),
  ['RuleNotFound'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
